<script setup lang="ts">
import { onMounted, ref,watch } from "vue";
import AxiosVideoService from "../utils/axiosVideoService";
import { useRouter } from 'vue-router';
const axiosVideoService = new AxiosVideoService();
const router = useRouter();

let allVideo: any = ref();
let vOpen: any = ref(false);
const props = defineProps({  
    vOpen: {
        required: false,
    },
})
const emit = defineEmits(['update:vOpen'])

const boolChange = () => {
    
    vOpen.value = !vOpen.value
    
    emit('update:vOpen',vOpen.value)
}
watch(() => props.vOpen, (newVal) => {
    
    vOpen.value = newVal
    getVideoList(1, 5)
})

watch(() => router.currentRoute.value.params.id, (newValue) => {
    location.reload()
  
});

function goToUpload(vid: string){

    router.push({ name: 'Upload',params:{ id: vid }})


}
// let intervalId: NodeJS.Timer | null = null;
let intervalId: ReturnType<typeof setInterval> | null = null;


let allTranscribeCompleted = false; // 标志变量，默认为 false

let videoListState = ref(false); // 默认假设没有"pending"状态
function getVideoList(page: number, size: number){
    axiosVideoService.getVideoList(localStorage.token, page, size, learning_language.value)
    .then((res: any) => {
        
        allVideo.value = [] 
        //console.log('allVideo.value',allVideo.value);
        
        // By Updated Date
        let videoArr:any = res.data.items
        videoArr = videoArr.sort(function (a:any, b:any) {
            return a.updated_at < b.updated_at ? 1 : -1;
        });

        allTranscribeCompleted = videoArr.every((video: any) => video.transcribe_status !== 'pending');

        if (allTranscribeCompleted) {
            if (intervalId !== null) {
                // clearInterval(intervalId);
            }
        }
        for(let i = 0; i < res.data.items.length; i++){
            allVideo.value.push(videoArr[i])
            if(res.data.items[i].transcribe_status === "pending") {
                videoListState.value = true; 
                break;
            }else{
                videoListState.value = false; 
            }
        }
    })
    .catch((r: any) => {
        console.log('list video failed',r.data);
    })
    
    
}

function startInterval() {
    if (intervalId !== null) return;

    intervalId = setInterval(() => {
        getVideoList(1, 5);
    }, 10000);
}

function stopInterval() {
    if (intervalId !== null) {
        window.clearInterval(intervalId);
        intervalId = null; // 清除intervalId，确保定时器已停止
    }
}

watch(() => videoListState.value, (newValue, oldValue) => {
    if (newValue === true && oldValue === false) {
        // 如果videoListState从false变为true，重新启动定时器
        startInterval();
    } else if (newValue === false) {
        // 如果videoListState变为false，停止定时器
        stopInterval();
    }
});


const learning_language = ref()
onMounted(() => {

    learning_language.value = localStorage.getItem('learningLanguage')
    videoListState.value = true; 
    startInterval();

})

</script>

<template>
    <div id="downloadlModal" class="videoBox fixed open"  >
        <div class="modalTitle title-3 bg-dark white flex j-between pointer" @click="boolChange">Video Transcript Processing<div class="icon-down sm pointer white" ></div></div>
        <div class="modalContent scroll bg-white" v-if="vOpen">
            <div class="flex j-end mb-5" >
                <router-link to="/user/saved/videolist" class="link pointer">view all</router-link>
            </div>
            <div  class="videoItem flex j-between a-center " :class="[item.transcribe_status == 'success' ? 'pointer': '']" v-for="item in allVideo" :key="item.id" @click="item.transcribe_status == 'success' ? goToUpload(item.id) :''">
                <div class="flex a-center gap-10">
                    <span class="icon-play" :class="[item.transcribe_status == 'success' ? 'pr-color': 'black-4']"></span>
                    <div>
                        <p class="content" :class="[item.transcribe_status == 'success' ? '': 'black-3']">{{ item.title ? item.title: item.video_url }}</p>
                        <span class="font-2" :class="[item.transcribe_status == 'pending' ? 'sd-color': item.transcribe_status == 'not_started'? 'black-3': 'pr-color']">{{item.transcribe_status == 'pending' ? 'Compiling 80%': item.transcribe_status == 'not_started' ? 'Preparing to compile': '' }}</span>
                        <div class="vProgress" v-if="item.transcribe_status == 'pending'"></div>
                    </div>
                </div>
                <div class="flex a-center gap-5">
                    <span class="font-2" :class="[item.transcribe_status == 'pending' ? 'sd-color': item.transcribe_status == 'not_started'? 'black-3': item.transcribe_status == 'fail'? 'alert' : 'pr-color']">{{ item.transcribe_status }}</span>
                    <img class="s-15" :src="item.transcribe_status == 'success' ? '/icon-confirm.png': item.transcribe_status == 'pending' ? '/icon-warn.png' : item.transcribe_status == 'fail' ? '/icon-alert.png' : '/icon-not-confirm.png'" alt="">

                </div>
                
            </div>
            
            
        </div>


    </div>
 
</template>
<style scoped>
@import '../assets/styles/frontpage.css';

.videoBox{
    width: 400px;
    max-width: 90%;
    bottom: 0;
    right: 20px; 
    display: none;
}
.videoBox.open{
    display: block;

}
.videoBox > .modalTitle{
    padding: 5px 15px;
}
.videoBox > .modalContent{
    max-height: 350px;
    padding: 10px;
}

.videoItem{
    padding: 10px;
}
.videoItem:hover{
    background: #FBF7F4;
}

.vProgress{
    margin-top: 5px;
    height: 6px;
    border-radius: 7px;
    background-image: linear-gradient(to right, #FFB805 80%,#D0CECE 0);
}
</style>